import { observer } from "mobx-react";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

interface IProps {
  accessInformation: string;
  address: string;
  storeMapURL: string;
  prefectureName: string;
}


const StoreAccessInfoTab = (props:IProps) => {
  return (
    <>
        <p className="store-address d-flex align-items-center gap-2"><i className="bi bi-geo-alt-fill text-primary fs-4"></i>{props.prefectureName}{props.address}</p>
        
        <p className="store-description">
          <FormattedMessage id="access_information" /> :{" "}
          {props.accessInformation}
        </p>
        
        <div className="border my-3">
            <h3 className="p-3 border-bottom fw-normal"><FormattedMessage id="place" /></h3>
            <div className="p-3">
                <div className="place_frame_wrap"
                  dangerouslySetInnerHTML={{ __html: props.storeMapURL }}
                />
            </div>
        </div>        
    </>
  );
};

export default observer(StoreAccessInfoTab);
